import { useState } from 'react'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { Services } from '../../../../../../store/slices/timesheet/timesheetPageSlice'
import { TimesheetStoreState } from '../../../../../../store/timesheetStore'

export const useServiceState = (serviceDetail: Services, instance: number) => {
	const timesheetPage = useSelector((state: TimesheetStoreState) => state.timesheetPage)

	const [passengers, setPassengers] = useState<number>(
		serviceDetail.serviceExecution?.pax ?? timesheetPage?.services[instance].service.pax ?? 0,
	)
	const [startTime, setStartTime] = useState<string>(
		dayjs(
			serviceDetail.serviceExecution?.startDateTime ??
				timesheetPage.services[instance].service.startDateTime ??
				'0000-00-00T00:00',
		).format('HH:mm'),
	)
	const [startDate, setStartDate] = useState<string>(
		dayjs(
			serviceDetail.serviceExecution?.startDateTime ??
				timesheetPage.services[instance].service.startDateTime ??
				'0000-00-00',
		).format('YYYY-MM-DD'),
	)
	const [endTime, setEndTime] = useState<string>(
		dayjs(
			serviceDetail.serviceExecution?.endDateTime ??
				timesheetPage.services[instance].service.endDateTime ??
				'0000-00-00T00:00',
		).format('HH:mm'),
	)
	const [endDate, setEndDate] = useState<string>(
		dayjs(
			serviceDetail.serviceExecution?.endDateTime ??
				timesheetPage.services[instance].service.endDateTime ??
				'0000-00-00',
		).format('YYYY-MM-DD'),
	)

	const [startTimeTooltipOpen, setStartTimeTooltipOpen] = useState(false)
	const [endTimeTooltipOpen, setEndTimeTooltipOpen] = useState(false)
	const [totalKmsTooltipOpen, setTotalKmsTooltipOpen] = useState(false)
	const [totalKmsInNotEmptyTooltipOpen, setTotalKmsInNotEmptyTooltipOpen] = useState(false)
	const [totalKmsEmptyTooltipOpen, setTotalKmsEmptyTooltipOpen] = useState(false)
	const [passengersTooltipOpen, setPassengersTooltipOpen] = useState(false)

	return {
		passengers,
		setPassengers,
		startTime,
		setStartTime,
		startDate,
		setStartDate,
		endTime,
		setEndTime,
		endDate,
		setEndDate,
		startTimeTooltipOpen,
		setStartTimeTooltipOpen,
		endTimeTooltipOpen,
		setEndTimeTooltipOpen,
		totalKmsTooltipOpen,
		setTotalKmsTooltipOpen,
		totalKmsInNotEmptyTooltipOpen,
		setTotalKmsInNotEmptyTooltipOpen,
		totalKmsEmptyTooltipOpen,
		setTotalKmsEmptyTooltipOpen,
		passengersTooltipOpen,
		setPassengersTooltipOpen,
	}
}
